import { FlowsInput, FlowsOutput } from 'hooks/data/datasets/V4/flows/types';

export const NODE_WIDTH = 330;
export const DATASET_NODE_WIDTH = 330;
export const DATASET_NODE_HEIGHT = 155;
export const H_GAP = 220;
export const V_SPACING = 40;
export const GRAPH_HEIGHT = 560;

const HEIGHT_WITH_SUPPLIER = 104;
const HEIGHT_NO_SUPPLIER = 80;

export const estimateFlowNodeHeight = (flow: FlowsInput | FlowsOutput): number => {
  const hasSupplier = 'supplier_count' in flow && flow.supplier_count !== undefined;
  return hasSupplier ? HEIGHT_WITH_SUPPLIER : HEIGHT_NO_SUPPLIER;
};
